import { mixins, Pie } from "vue-chartjs";

export default {
  name: "PieChart",
  extends: Pie,
  mixins: [mixins.reactiveProp],
  props: {
    extraOptions: Object,
  },
  data() {
    return {
      ctx: null,
    };
  },
  mounted() {
    this.$watch(
      "chartData",
      (newVal, oldVal) => {
        if (!oldVal) {
          this.renderChart(this.chartData, this.extraOptions);
        }
      },
      { immediate: true }
    );
  },
};
